<div class="alert-banner" *ngIf="newAlerts">
  <div class="alert valign-children-middle">
    <div class="banner-icon" role="alert">
      <i class="icon-badgealert" role="img" aria-label="Alert." tabindex="0"></i>
    </div>
    <div class="description"> 
      <span class="lg-hide">{{newAlerts + (newAlerts > 1 ? ' alerts are' : ' alert is' )}} ready for your review.
        <a (click)="showAlerts($event)" (keyup)="showAlerts($event)">  {{newAlerts > 1 ? ' View alerts' : ' View alert'}}</a>
        </span>
      <span class="sm-hide">{{newAlerts + (newAlerts > 1 ? ' alerts are' : ' alert is' )}} ready for your review.
      <br>
        <a (click)="showAlerts($event)" (keyup)="showAlerts($event)">  {{newAlerts > 1 ? ' View alerts' : ' View alert'}}</a>
      </span>
    </div>
    <div class="banner-close" (click)="dismissInfo($event)" (keydown)="dismissInfo($event)">
      <i class="icon-close" role="img" aria-label="Close AT&T Business Console." tabindex="0"></i>
    </div>
  </div>
</div>
